import { z } from '@bonanza-social/toolkit/api';

export const LoyaltyPointsByGameTypeSchema = z.object({
  gameType: z.string(),
  displayName: z.string(),
  loyaltyPoints: z.number(),
});

export const LoyaltyPointsByGameTypesSchema = z.object({
  gameTypesLoyaltyPoints: z.array(LoyaltyPointsByGameTypeSchema),
});
